
import { Button, Drawer } from 'antd'
import React from 'react'
import { SearchOutlined } from '@ant-design/icons';

export default function BaseAdvanceFilter(props) {
    const { children, onClose, onSearchClick = () => { }, title = "Advance Filter" } = props
    return (
        <div>
            <Drawer {...props} title={title} placement="left" onClose={onClose} open={true} size='large' extra={
                <>
                    <Button type='primary' onClick={onSearchClick} icon={<SearchOutlined />}>Search</Button>
                </>
            }>
                {children}
            </Drawer>
        </div>
    )
}
